import {useEffect, useState, RefObject, useRef} from 'react'

type Options = IntersectionObserverInit

const useIntersectionObserver = (ref: RefObject<Element>, options?: Options): boolean => {
  const [isIntersecting, setIsIntersecting] = useState(true)

  const timeoutRef = useRef<any>(null)

  useEffect(() => {
    const element = ref.current
    if (!element) return

    const observer = new IntersectionObserver(([entry]) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }

      timeoutRef.current = setTimeout(() => {
        requestAnimationFrame(() => {
          setIsIntersecting(entry.isIntersecting)
        })
      }, 200)
    }, options)

    observer.observe(element)

    return () => {
      observer.disconnect()
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [ref, options?.root, options?.rootMargin, options?.threshold])

  // useEffect(() => {
  //   const element = ref.current
  //   if (!element) return

  //   const observer = new IntersectionObserver(([entry]) => {
  //     requestAnimationFrame(() => {
  //       setIsIntersecting(entry.isIntersecting)
  //     })
  //   }, options)

  //   observer.observe(element)

  //   return () => {
  //     observer.disconnect()
  //   }
  // }, [ref, options?.root, options?.rootMargin, options?.threshold])

  return isIntersecting
}

export default useIntersectionObserver
